/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import P1 from '@base/P1/P1';
import H1 from '@base/H1/H1';
import Link from '@base/Link/Link';
import { breakpoints, Fonts, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import useScholarshipTestInfo from '@api/hooks/scholarship/useScholarshipTestInfo';

const Wrapper = styled.div`
  padding-top: 120px;
  padding-bottom: ${Spacings.SPACING_15B};
  margin-bottom: -${Spacings.SPACING_10B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    height: unset;
    padding: ${Spacings.SPACING_4B};
  }
`;

const Content = styled.div`
  max-width: 1136px;
  margin: auto;
  height: 444px;
  background-color: var(--color-base-1);
  display: flex;
  padding: ${Spacings.SPACING_20B};
  border-radius: 8px;
  box-shadow: ${boxShadowGenerator()};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    flex-direction: column-reverse;
    height: unset;
    padding: ${Spacings.SPACING_6B};
    margin-top: ${Spacings.SPACING_12B};
  }
`;

const LeftContent = styled.div`
  flex: 1;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    text-align: center;
  }
  h1 {
    line-height: 120%;
    margin-bottom: ${Spacings.SPACING_4B};
  }
  p {
    font-size: 20px;
  }
`;

const RightImage = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    margin-bottom: ${Spacings.SPACING_10B};
  }
  img {
    position: absolute;
    bottom: -${Spacings.SPACING_20B};
    right: ${Spacings.SPACING_7B};
    @media only screen and (max-width: ${breakpoints.tablet}) {
      position: relative;
      height: 300px;
      right: unset;
      bottom: unset;
    }
  }
`;

const StyledP1 = styled(P1)`
  font-size: ${Fonts.LARGE};
  max-width: 1136px;
  margin: auto;
  margin-top: ${Spacings.SPACING_15B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const AppIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${Spacings.SPACING_6B};
  img {
    height: 48px;
    margin-right: ${Spacings.SPACING_4B};
    cursor: pointer;
  }
`;

const AppImage = styled.img`
  height: 372px;
  width: 382px;
  position: absolute;
  bottom: 0px;
  @media only screen and (max-width: 540px) {
    width: 100%;
    height: unset;
    position: relative;
    margin-bottom: 16px;
  }
`;

const Footer = () => {
  const {
    query: { eventKey }
  } = useRouter();
  const { prodigyInfo } = useScholarshipTestInfo(eventKey);

  const { footerText, footerTitle, footerSubTitle } = prodigyInfo;

  return (
    <Wrapper>
      <Content>
        <LeftContent>
          <H1 as="h2">{footerTitle}</H1>
          <P1>{footerSubTitle}</P1>
          <AppIconsWrapper>
            <Link
              newTab
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26"
            >
              <img src={getImage('play_store.png')} alt="play-store" />
            </Link>
            <Link
              newTab
              href="https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
            >
              <img src={getImage('app_store.png')} alt="app-store" />
            </Link>
          </AppIconsWrapper>
        </LeftContent>
        <RightImage>
          <AppImage src={getImage('newApp.png')} alt="app" />
        </RightImage>
      </Content>
      <StyledP1 color="var(--color-text-secondary)">{footerText}</StyledP1>
    </Wrapper>
  );
};

export default Footer;
